import React from "react";
import { Phone, Mail, Facebook } from "lucide-react";

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-black text-white py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Main Footer Content */}
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* Company Info */}
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <img
                  src="https://customer-assets.emergentagent.com/job_7494b2a0-84f7-4e80-9b8b-bf9c894cb7dd/artifacts/x2ziob80_Logo%20sin%20fondo.png"
                  alt="Samaniega's Landscaping"
                  className="h-12 w-auto"
                />
              </div>
              <h3 className="text-xl font-bold mb-2">
                Samaniega's Landscaping LLC
              </h3>
              <p className="text-gray-400 mb-4">
                Residential & Commercial Landscaping Services
              </p>
              <div className="flex flex-wrap gap-2">
                <span className="text-sm bg-green-500/20 text-green-400 px-3 py-1 rounded-full">
                  Free Estimates
                </span>
                <span className="text-sm bg-green-500/20 text-green-400 px-3 py-1 rounded-full">
                  Licensed
                </span>
                <span className="text-sm bg-green-500/20 text-green-400 px-3 py-1 rounded-full">
                  Bonded
                </span>
                <span className="text-sm bg-green-500/20 text-green-400 px-3 py-1 rounded-full">
                  Insured
                </span>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <button
                    onClick={() => scrollToSection("home")}
                    className="text-gray-400 hover:text-green-400 transition-colors"
                  >
                    Home
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("about")}
                    className="text-gray-400 hover:text-green-400 transition-colors"
                  >
                    About Us
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("services")}
                    className="text-gray-400 hover:text-green-400 transition-colors"
                  >
                    Services
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("gallery")}
                    className="text-gray-400 hover:text-green-400 transition-colors"
                  >
                    Gallery
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("contact")}
                    className="text-gray-400 hover:text-green-400 transition-colors"
                  >
                    Contact
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-bold mb-4">Contact Us</h4>
              <div className="space-y-3">
                <a
                  href="tel:2067080084"
                  className="flex items-center space-x-3 text-gray-400 hover:text-green-400 transition-colors"
                >
                  <Phone className="h-5 w-5 flex-shrink-0" />
                  <span>(206) 708-0084</span>
                </a>
                <a
                  href="mailto:miguel@samaniegaslandscapingllc.com"
                  className="flex items-center space-x-3 text-gray-400 hover:text-green-400 transition-colors break-all"
                >
                  <Mail className="h-5 w-5 flex-shrink-0" />
                  <span>miguel@samaniegaslandscapingllc.com</span>
                </a>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 text-gray-400 hover:text-green-400 transition-colors"
                >
                  <Facebook className="h-5 w-5 flex-shrink-0" />
                  <span>Samaniega's Landscaping</span>
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-800 pt-8">
            <div className="text-center text-gray-400">
              <p className="mb-2">
                © {new Date().getFullYear()} Samaniega's Landscaping LLC. All
                rights reserved.
              </p>
              <p className="text-sm">
                Proudly serving Washington State | Owner: Miguel Soltero
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
